import { MessageType, Urls } from 'kts-platform-frame/entry/constant';
import { IAppInfo } from 'kts-platform-frame/dataModel';
import sharedObject from 'kts-platform-frame/sharedObject';

/** 系统数据节点 */
export default class Node {

    /** 正在加载的服务器接口 (代替 loading ) */
    public loadingUrls: Map<Urls, string> = new Map<Urls, string>();

    /** 未读消息数量 */
    public messageUnread: number = 0;

    /** 菜单可以显示的APP */
    public menuAppList: IAppInfo[] = [];

    /** 初始化参数 */
    public initializationParameter: string;

    /** 语言版本 */
    public languageVersion: string = new Date().getTime().toString();

    /** default:默认 silent:静默  */
    public loginType: 'silent' | 'default' = 'default';

    /** 版本 */
    public version: '0.2' | '0.3' = sharedObject.get('$$/system/version') as any | '0.3';
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/system/Node.ts